import React from 'react';
import styles from './ServiceCard.module.css';

const ServiceCard = ({ icon, title, description }) => {
  return (
    <div className={styles.card}>
      <div className={styles.cardBackground}></div>
      <div className={styles.cardContent}>
        <div className={styles.iconWrapper}>
          <div className={styles.iconGlow}></div>
          <div className={styles.icon}>{icon}</div>
        </div>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
        <div className={styles.cardFooter}>
          <span className={styles.learnMore}>Learn More →</span>
        </div>
      </div>
      <div className={styles.cardShine}></div>
    </div>
  );
};

export default ServiceCard;
